module.exports = __webpack_public_path__ + "img/INSTAGRAM.f6e7099b.svg";